export default __webpack_public_path__ + "static/media/joni.36985e19.png";